import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

// Matches the opacity transition on `fuse-splash-screen` in styles/splash-screen.css.
const FADE_OUT_MS = 400;

@Injectable({ providedIn: 'root' })
export class FuseSplashScreenService {
    private _document = inject(DOCUMENT);
    private _router = inject(Router);

    /**
     * Constructor
     */
    constructor() {
        // Hide it on the first NavigationEnd event
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                this.hide();
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void {
        this._document.body.classList.remove('fuse-splash-screen-hidden');
    }

    /**
     * Hide the splash screen
     */
    hide(): void {
        this._document.body.classList.add('fuse-splash-screen-hidden');

        // The hidden state is `visibility: hidden`, which does not stop CSS animations —
        // the spinner's 25 infinite keyframes would tick for the lifetime of the app.
        // Drop the element once the fade-out has finished.
        const splashScreen =
            this._document.querySelector('fuse-splash-screen');

        setTimeout(() => splashScreen?.remove(), FADE_OUT_MS);
    }
}
